import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "logo-container" }
const _hoisted_3 = { class: "font-size-18-600" }
const _hoisted_4 = { class: "font-size-10-400 font-grey-dark" }
const _hoisted_5 = { class: "font-black font-size-10-600" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "mt-5 font-size-12-600" }
const _hoisted_8 = { class: "d-flex align-center justify-space-between" }
const _hoisted_9 = { class: "font-size-16-600" }
const _hoisted_10 = { class: "d-flex align-center justify-space-between" }
const _hoisted_11 = { class: "font-size-16-600" }
const _hoisted_12 = { class: "d-flex align-center justify-space-between" }
const _hoisted_13 = { class: "font-size-16-600" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_15 = { class: "font-size-16-600" }

import {computed} from "vue";
import OrderCardItemDetails from "@/views/OrdersComponents/OrderDetails/OrderCardItemDetails.vue";
import moment from "moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderCardView',
  props: {
  order: {
    type: Object,
  },
  orderItems: {
    type: Array,
  },
  supplierOrder: {
    type: Object,
  },
  supplierId: {
    type: String,
  },
  clinicAvatar: {
    type: Object,
  },
  orderType: {
    type: String,
  },
  hasMultipleOrders: {
    type: Boolean,
  }
},
  setup(__props) {

const props = __props;

const getClinicAvatar = computed(() => {
  if (props.supplierId == 'clinic') {
    return props.clinicAvatar?.file.file_path ?? ''
  }

  return '/img/tnd_hands_logo.png'
})

const getPaymentStatus = computed(() => {
  const paymentStatus = props.order.payment_status;
  const orderCreationDate = moment(props.order.created_at);

  // Calculation of overdue time limit
  const overdueTimeLimit = moment(orderCreationDate).add(24, 'hours');

  const isOverdue = paymentStatus === 'not_paid' && moment().isAfter(overdueTimeLimit);

  switch (props.order.payment_status) {
    case 'paid':
      return {
        color: 'font-success',
        status: '(Paid)'
      }
    case 'partial':
      return {
        color: 'font-warning',
        status: '(Part Paid)'
      }
    case 'processing':
      return {
        color: 'font-info',
        status: '(Processing)'
      }
    case 'chargeback':
    case 'failed':
      return {
        color: 'font-success',
        status: '(Failed)'
      }
    case 'not_paid':
      if (isOverdue) {
        return {
          color: 'font-danger',
          status: '(Overdue)'
        };
      } else {
        return {
          color: 'font-danger',
          status: '(Not Paid)'
        };
      }
    default:
      return {
        color: '',
        status: ''
      }
  }
})

const orderDetails = computed(() => {
  return {
    vat: props.supplierOrder?.tax ?? '-',
    discount: `${props.supplierOrder?.currency_symbol}${props.supplierOrder?.discount}` ?? '-',
    discount_code: props.supplierOrder?.discount_code ?? '-',
    total: `${props.supplierOrder?.currency_symbol}${props.supplierOrder?.total.toFixed(2)}` ?? '-',
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_v_sheet, {
        class: _normalizeClass([{
          'clinic-logo-border secondary-background-button-color': __props.supplierId === 'clinic', 
          'logo-default-border': __props.supplierId !== 'clinic'
        }, "logo-container__content"])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle({backgroundImage: `url(${getClinicAvatar.value})`}),
            class: "logo-container__image"
          }, null, 4)
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createVNode(_component_v_card, { class: "card-container" }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(__props.orderType), 1),
          _createElementVNode("p", _hoisted_4, [
            _cache[0] || (_cache[0] = _createTextVNode(" Order ID: ", -1)),
            _createElementVNode("span", _hoisted_5, "#" + _toDisplayString(__props.order?.id), 1)
          ])
        ]),
        (__props.orderItems)
          ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orderItems, (item, index) => {
                return (_openBlock(), _createBlock(OrderCardItemDetails, {
                  key: `item-${item.id}`,
                  border: index !== __props.orderItems.length - 1,
                  item: item,
                  order: __props.order,
                  "payment-status": getPaymentStatus.value,
                  "supplier-id": __props.supplierId,
                  "supplier-order": __props.supplierOrder
                }, null, 8, ["border", "item", "order", "payment-status", "supplier-id", "supplier-order"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("p", null, "Discount Code", -1)),
            _createElementVNode("p", _hoisted_9, _toDisplayString(orderDetails.value.discount_code), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[2] || (_cache[2] = _createElementVNode("p", null, "Discount", -1)),
            _createElementVNode("p", _hoisted_11, _toDisplayString(orderDetails.value.discount), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[3] || (_cache[3] = _createElementVNode("p", null, "VAT", -1)),
            _createElementVNode("p", _hoisted_13, _toDisplayString(orderDetails.value.vat), 1)
          ]),
          (__props.hasMultipleOrders)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[4] || (_cache[4] = _createElementVNode("p", null, "Subtotal", -1)),
                _createElementVNode("p", _hoisted_15, _toDisplayString(orderDetails.value.total), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})